export default __webpack_public_path__ + "images/ce9765f56b21a9c63d74c098eb3f1be5.svg";